<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto=true ></Header>
    <div class="col-lg-12 mx-auto p-3 py-md-5">
        <main>
          <div class="container" style="display: flex; flex-direction: row; justify-content: space-between; gap: 20px;">    
            <div style="flex: 1; border: 1px solid #ccc; padding: 15px; display: flex; justify-content: space-between; gap: 20px; border-radius: 22px;">
              <div style="display: flex; flex-direction: column; gap: 10px;">
                <span>Fecha de ingreso:</span>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <date-picker v-model="fecha" valueType="format" format="DD-MM-YYYY"></date-picker>
                </div>
              </div>       
                <div style="display: flex; gap: 10px; align-items: center;">
                    <button type="button" class="btn btn-secondary" v-on:click="limpiarFiltros()">Limpiar filtros</button>
                    <button type="button" class="btn btn-primary" v-on:click="buscar(1)">Buscar</button>
                  </div>
              </div>
            </div>
            <br />
            <h3>Reporte Lista de espera</h3>

            <hr class="" />

        <table class="table table-responsive table-striped align-middle" style="">
          <thead>
            <tr>
              <th scope="col" class="col-2">Restaurante</th>
              <th scope="col" class="col-2">Fecha</th>
              <th scope="col" class="col-2">Nombre</th>
              <th scope="col" class="col-2">Apellido</th>
              <th scope="col" class="col-3">Correo</th>
              <th scope="col" class="col-2">Tiempo de espera</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="listaEspera.length == 0">
              <td colspan="11">
                <h4 class="text-center">NO DATA</h4>
              </td>
            </tr>
            <tr v-for="(espera, index) in listaEspera" :key="index">
              <td>{{ espera.restaurante || "-" }}</td>
              <td>{{ espera.fecha.replace('T', ' ') }}</td>
              <td>{{ espera.nombre }}</td>
              <td>{{ espera.apellido}}</td>
              <td>{{ espera.correo }}</td>
              <td>{{ espera.tiempoEspera }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row">
        <div class="col-3">
          <div class="input-group mb-3">
          <label class="input-group-text" for="inputGroupSelect01">Resultados por pagina: &nbsp;</label>
          <select
            v-model="pageSizeSelected"
            @change="buscar(currentPage)"
            class="form-select"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="-1">Todos</option>
          </select>
          </div>
        </div>
          <div class="col-5">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="pageSizeSelected"
              @change="buscar($event)"
              last-number
            ></b-pagination>
          </div>
          <div class="col-3">
            <h6> <b>Total resultados: {{ this.totalRows }} </b></h6>
          </div>
        </div>

        <ExcelEsperaTodo :exportar="true" :data="listaEspera" :file="filename" :request="this.requestLast"></ExcelEsperaTodo>

        

      </main>
      <Footer />
    </div>
  </body>

  </html>
</template>

<script>
import axios from "axios";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ExcelEsperaTodo from "../components/ExcelEsperaTodo.vue";
export default {
  components: { Header, Footer, DatePicker, ExcelEsperaTodo },
  data: function () {
    return {
      filename: "",
      fecha: new Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-'),
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      pageSizeSelected: 10,
      currentPage: 0,
      totalRows: 0,
      requestLast:null,
      restaurantes: [],
      restaurante: null,
      listaEspera: []
    };
  },
  methods: {
    convertDataObjectUrl(data) {
      return Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
          
        })
        .join("&");
    },
    
    buscar(page) {
      
      this.currentPage = page;
      this.filtrado = [];

      
      let request = {
          size: this.pageSizeSelected,
          page: page - 1,
          search: JSON.stringify({ restaurante: {id: this.restaurante=="TODOS"?null:this.restaurante}, fechaCreacion: this.fecha}),
        };

        this.requestLast=request;
      axios.get("/getReporteEspera?"+ this.convertDataObjectUrl(request)).then((data) => {
        if (data.status == 200) {
          this.currentPage = page;
          this.totalRows = this.pageSizeSelected==-1?1:data.data.total;
          this.listaEspera = data.data.items;
        } else {
          this.error = true;
          this.error_msg =
            "No se ha podido buscar las reservas. Vuelva a intentar mas tarde";
        }
      });
    },
    limpiarFiltros() {
      this.fecha = '';
      this.restaurante = null;
    },
  },

  beforeMount() {
    this.filename = "restaurantes-reporte-espera";
    this.buscar(1);
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.mx-datepicker-range {
    width: 150px !important
}

</style>
